import { CQRS } from '@withlocals/cqrs.js/lib/index';

import { AuthenticationInfo } from '../../model/AuthenticationInfo';
import { AccountActions } from './commands';
import { accountMessageHandlerFactory } from './handlers';
import { AccountQueryProcessor } from './queries';

export class AccountAggregate extends CQRS<
  AccountActions,
  AccountQueryProcessor
> {
  constructor(protected authInfo: AuthenticationInfo) {
    super(
      new AccountActions(authInfo),
      new AccountQueryProcessor(authInfo),
      accountMessageHandlerFactory(authInfo),
    );
  }
}
